import { createAsyncThunk } from "@reduxjs/toolkit";
import "react-toastify/dist/ReactToastify.css";

import { formatQueryParams } from "helpers/format";
import bannerApi from "api/bannerApi";

export const getBannerPositionList = createAsyncThunk(
  "BannerPosition",
  async (params: any = {}) => {
    try {
      const response = await bannerApi.getBannerPositionList(
        formatQueryParams(params)
      );
      return response;
    } catch (error) {
      return error;
    }
  }
);

export const postBannerPosition = async (data: any = {}) => {
  try{
    const response = await bannerApi.createBannerPosition(data);
    return response;
  }catch (error) {
    return error;
  }
};

export const putBannerPosition = async (id: string | number , data: any = {}) => {
  try{
    const response = await bannerApi.updateBannerPosition(id, data);
    return response;
  }catch (error) {
    return error;
  }
};

export const deleteBannerPosition = async (id: string | number) => {
  try{
    const response = await bannerApi.deleteBannerPosition(id);
    return response;
  }catch (error) {
    return error;
  }
};